export enum PermitDataFieldName {
  permitType = 'permitType',
}
export interface PermitFormDataProps {
  [PermitDataFieldName.permitType]?: string;
}
